<template>
  <v-container fluid>
    <template>
      <v-card class="mt-4">
        <v-card-title>
          <h4 class="subheading grey--text">Φίλτρα</h4>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="8" sm="6">
              <v-text-field
                v-model.lazy="search"
                append-icon="mdi-magnify"
                label="Αναζήτηση"
                single-line
                clearable
                persistent-hint
                hint="Για αναζήτηση κωδικού βάλε μπροστά #"
              ></v-text-field>
            </v-col>
            <v-col cols=2>
               <v-select
                  :items=partCategories
                  label="Κατηγορία Ανταλλακτικού"
                  v-model="category"
                  :hint="`Cat-ID: ${category}`"
                  persistent-hint
                  item-text="Description"
                  item-value="CatId"
                  clearable
                ></v-select>
            </v-col>
            <v-col cols=2>
               <v-switch
                  v-model="inStock"
                  label="Σε απόθεμα"
                ></v-switch>
            </v-col>
              <v-col cols=3>
                 <v-file-input
                  chips
                  prepend-icon="mdi-microsoft-excel"
                  accept=".xls,.xlsx"
                  label="Μαζική εισαγωγή ανταλλακτικών"
                  placeholder="Επιλέξτε αρχείο ανταλλακτικών"
                  v-model="partsFile"
                >
                <template v-slot:append>
                <v-btn @click="updateParts" icon><v-icon>mdi-update</v-icon></v-btn>
			</template></v-file-input>

              </v-col>
              </v-row>
              <v-row>
              <v-col>
                <v-dialog
              v-model="dialog"
              persistent
              max-width="600px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  v-bind="attrs"
                  small
                  v-on="on"
                >
                <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="text-h5">Στοιχεία Ανταλλακτικού</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col
                        cols="12"
                      >
                       <v-select
                          :items=partCategories
                          label="Κατηγορία Ανταλλακτικού*"
                          v-model="newPart.CategoryId"
                          :hint="`Cat-ID: ${newPart.CategoryId}`"
                          item-text="Description"
                          item-value="CatId"
                          required
                        ></v-select>
                        <v-text-field
                          label="Κωδικός Ανταλλακτικού*"
                          v-model.number="newPart.PartId"
                          type="number"
                          required
                          :rules=[rules.partId]
                        ></v-text-field>

                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                      >
                        <v-text-field
                          label="Περιγραφή Ανταλλακτικού"
                          v-model="newPart.Description"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-textarea
                          label="Αντιστοιχίες"
                          v-model="newPart.References"
                        >
                        </v-textarea>
                      </v-col>
                      <v-col cols="12">
                        <v-textarea
                          label="Τεχνικά Χαρακτηριστικά"
                          v-model="newPart.PartProperties"
                        >
                        </v-textarea>
                      </v-col>
                    </v-row>
                  </v-container>
                  <small>* Υποχρεωτικά πεδία</small>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="dialog = false"
                  >
                    Κλεισιμο
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="createPart"
                  >
                    Αποθηκευση
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
             <v-dialog
                v-model="dialogPart"
                persistent
                max-width="600px"
              >
                <template v-slot:activator="{on, attrs}">
                    <v-btn
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      class="ml-2 white--text">
                      <v-icon dark>mdi-plus</v-icon>Ανταλλακτικο
                    </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="text-h5">{{ formTitle }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-form ref="invoice">
                    <v-container>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-text-field
                            label="Κωδικός Προμηθευτή"
                            :rules="[rules.required]"
                            v-model="editedItem.SupplierSku"

                            >
                             <template v-slot:append>
                             <v-btn @click="copySku" icon><v-icon>mdi-content-copy</v-icon></v-btn>
                            </template>
                            </v-text-field>
                        </v-col>
                        <v-col
                          cols="6"
                          sm="6"
                          md="4"
                        >
                          <v-text-field
                            label="Κωδικός Κατασκευαστή"
                            :rules="[rules.required]"
                            v-model="editedItem.ManufacturerSku"

                            ></v-text-field>
                        </v-col>
                        <v-col
                          cols="6"
                          sm="6"
                          md="4"
                        >
                          <v-combobox
                            label="Κατασκευαστής"
                            :rules="[rules.required]"
                            :items="manufacturers"
                            v-model="editedItem.Manufacturer"

                            ></v-combobox>
                        </v-col>
                      <v-col cols="4" sm="4" md=4>
                          <v-text-field
                            label="Ποσότητα*"
                            :rules="[rules.required]"
                            v-model="editedItem.Qty"

                            required
                            ></v-text-field>

                      </v-col>
                      <v-col cols="4" sm="4" md=4>
                          <v-text-field
                            label="Αποθήκη*"
                            :rules="[rules.required]"
                            v-model="editedItem.StockQty"
                            dense
                            required
                            ></v-text-field>
                      </v-col>
                       <v-col cols="12" sm="12" md=12>
                        <v-autocomplete
                          v-model="editedItem.PartId"
                          :loading="isLoading"
                          :items="parts"
                          cache-items
                          hide-no-data
                          hide-details
                          item-text='Description'
                          item-value='Id'
                          :hint="`${select.FmSku} ${select.Id}`"
                          persistent-hint
                          label="Ανταλλακτικό"
                        >
                          <template v-slot:selection="data">
                            {{ data.item.Id }}: {{ data.item.FmSku }} - {{ data.item.Description }}
                          </template>
                            <template v-slot:item="data">
                              <template v-if="typeof data.item !== 'object'">
                                <v-list-item-content v-text="data.item"></v-list-item-content>
                              </template>
                              <template v-else>
                                <v-list-item-content>
                                  <v-list-item-title v-html="data.item.FmSku"></v-list-item-title>
                                  <v-list-item-subtitle v-html="data.item.Description"></v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="6" sm="6" md=4>
                          <v-text-field
                            label="Τιμή*"
                            :rules="[rules.required]"
                            v-model.number="editedItem.RetailPrice"
                            type="number"
                            dense
                            required
                            ></v-text-field>
                      </v-col>

                     <v-col cols="6" sm="6" md=4>
                          <v-text-field
                            label="Εκπτωση*"
                            :rules="[rules.required]"
                            v-model.number="editedItem.Discount"
                            suffix="%"
                            dense
                            type="number"
                            required
                            ></v-text-field>
                      </v-col>
                      <v-col cols="6" sm="6" md=4>
                          <v-text-field
                            label="Κέρδος* "
                            :rules="[rules.required]"
                            v-model.number="editedItem.Profit"
                            suffix="%"
                            dense
                            type="number"
                            required
                            ></v-text-field>
                      </v-col>
                       <v-col cols="6" sm="6" md=4>
                          <v-text-field
                            label="Λιανική"
                            v-model.number="suggestedPrice"
                            dense
                            suffix="€"
                            read-only
                            ></v-text-field>
                      </v-col>
                      <v-col cols="6" sm="6" md=4>
                    <v-select
                        label="Μονάδα Μέτρησης"
                        v-model="editedItem.Unit"
                        :items="['ΤΕΜ', 'ΣΕΤ', 'ΚΙΛΑ', 'ΚΥΒΙΚΑ', 'ΛΙΤΡΑ', 'ΜΕΤΡA', '']"
                        dense
                        single-line>
                      </v-select>
                      </v-col>
                      <v-col cols="6" sm="6" md=4>
                          <v-select
                            label="Κατάσταση"
                            :rules="[rules.required]"
                            v-model="editedItem.Status"
                            :items="statuses"
                            dense single-line
                            required
                            ></v-select>
                      </v-col>
                      </v-row>
                      <v-row>
                      <v-col cols=12 md=12>
                      <v-textarea
                        v-model="editedItem.Remarks"
                        prepend-icon="mdi-notebook"
                        rows="1"
                        :auto-grow=true
                        label="Σημειώσεις"
                        hint="Αριθμός πλαισίου, όχημα, κλπ"
                        >
                     </v-textarea>
                     </v-col>
                    </v-row>
                    </v-container>
                    <small>*indicates required field</small>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="dialogPart = false"
                    >
                      Κλείσιμο
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="save"
                    >
                      Αποθήκευση
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            
              </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </template>

  <template>
  <v-card class="ma-0 mt-4"
    :loading="loading"
    >
    <v-card-title>
       <h1 class="mr-2 subheading grey--text">Λίστα Ανταλλακτικών</h1>
        <v-btn icon @click="$router.push({name:'orders'})"><v-icon>mdi-clipboard-list</v-icon></v-btn>
       <v-spacer/>
            <div class="barcode-input-container">
              <v-text-field
                v-if="showBarcodeInput"
                label="Scan Barcode"
                @keyup.enter="handleBarcodeEnter"
                hide-details
                dense
                class="barcode-text-field"
                ref="barcodeInput"
                :error-messages="barcodeError"
              ></v-text-field>
                <v-switch
                  v-if="showBarcodeInput"
                  v-model="openInNewTab"
                  class="ml-2"
                  :label="''"
                >
                  <template v-slot:prepend>
                    <v-icon>mdi-open-in-new</v-icon>
                  </template>
                </v-switch>
              <v-btn icon @click="toggleBarcodeInput" class="barcode-btn">
                <v-icon>mdi-barcode-scan</v-icon>
              </v-btn>
            </div>  
            <v-spacer/>
            
            <v-chip v-if="isAdmin" label outlined>
              {{
              tocurr(partsCost)
              }}
              ({{
              tocurr(partsSaleValue)
              }})
            </v-chip>

    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="partsFiltered"
      loading: false
      item-key="Id"
      class="elevation-1"
      :loading="loading"
      single-expand: true
      :expanded.sync="expanded"
      show-expand
      :options.sync="options"
      :server-items-length="partsLength"
      loading-text="Loading... Please wait"
    >
    <template v-slot:item.actions="{ item }">
        <v-btn
          icon
          small
          :to="{name: 'part-info', params: {id: item.Id}}"
        >
         <v-icon>mdi-information-variant</v-icon>
        </v-btn>
     </template>

    <template v-slot:item.RetailPrice="{ item }">
       {{ tocurr(item.RetailPrice) }}
    </template>
    <template v-slot:item.CategoryId="{ item }">
       {{ partCategories.find(i => i.CatId === item.CategoryId).Description }}
    </template>
     <template v-slot:expanded-item="{ headers, item }">
       <tr>
      <td :colspan="headers.length">
        More info about {{ item.FmSku }}
        <p>Related invoices:</p>
      </td>
      </tr>
      <v-list-item v-for='i in item.Orders' :key=i.Id>
            <v-list-item-content>
             <v-list-item-title> {{ i.Id }}
               <v-btn
                    icon
                    :to="'/invoice/details/'+i.Id"
                  >
                  <v-icon>mdi-git</v-icon>
                  </v-btn>
             </v-list-item-title>
             {{ i.Manufacturer }} - {{ i.ManufacturerSku }} - {{ i.SupplierSku }}
            </v-list-item-content>
            </v-list-item>
    </template>
    </v-data-table>
  </v-card>
</template>
  </v-container>
</template>

<script>

//import QuoteCard from '../../components/QuoteCard.vue';


export default {
  components: {
 //   QuoteCard
  },
  computed: {
      dateRangeText () {
        return this.filter_dates.join(' ~ ')
      },
      partsCost () {
        return this.parts.reduce((a, b) => a + (b.StockCost || 0), 0);
      },
      partsSaleValue () {
        return this.parts.reduce((a, b) => a + (b.SaleValue || 0), 0);
      },
      isAdmin() {
          if (!this.$store.state.authentication.user) return false;
          return this.$store.state.authentication.user.scopes.includes("income");
      },
      suggestedPrice () {
        return (this.editedItem.RetailPrice * (1-this.editedItem.Discount/100) * (1 + this.editedItem.Profit/100)).toFixed(2)
      },
      manufacturers() {
        return this.$manufacturers.map(e=>e.title);
      },
      partsFiltered () {
        if (!this.parts) return;
        return this.parts
        /* return this.parts.filter(
        function (o) {
        const refs = o.References
        const searchText = this.search.toUpperCase();
        const searchSku = this.search.replace(/[^\p{L}\p{N}]/gu, '');
        const ae = refs.some(o => o.Sku.replace(/[^\p{L}\p{N}]/gu, '').includes(searchSku));
        return o.Description.includes(searchText) || ae;
        }, this); 
        */
      }
  },
  data() {
    return {
      menu: false,
      expanded: [],
      dialog: false,
      loading: true,
      newPart: {CategoryId: 0},
      partCategories: [],
      vehicle: [],
      search: '',
      inStock: false,
      parts: [],
      options: {},
      category: null,
      partsLength: 1,
      partsFile: null,
      dialogPart: false,
      select: '',
      editedItem: {
          itemId: 0,
          Id: 0,
          PartId: 0,
          SupplierSku: '000-0000',
          ManufacturerSku: '000-0000',
          Manufacturer: '',
          Qty: 1,
          StockQty: 1,
          Unit: 'TEM',
          RetailPrice: 0,
          Discount: 0,
          Profit: 60,
          Status: 0,
          Remarks: '',
          TechId: 5,
    },
    defaultItem: {
      Id: 0,
      itemId: 0,
      PartId: 0,
      SupplierSku: '000-0000',
      ManufacturerSku: '000-0000',
      Manufacturer: '',
      Qty: 1,
      StockQty: 1,
      Unit: 'ΤΕΜ',
      RetailPrice: 0,
      Discount: 0,
      Profit: 60,
      Status: 0,
      Remarks: '',
      TechId: 5,
    },
    statuses: [
      {value: -2, text: "Χαλασμένο"},
      {value: -1, text: "Μεταχειρισμένο"},
      {value: 0, text: "Καινούργιο"},
      {value: 1, text: "Ανακατασευή"},
      {value: 2, text: "Επισκευασμένο"},
     ],
    barcodeError: '',
    showBarcodeInput: false,
    barcode: '',
    openInNewTab: false,
    partTechId: 1,
    isLoading: true,
    rules:  {
        partId: value => {
            const pattern = /^\d{1,5}$/
            return pattern.test(value) || 'Invalid Part-ID.'
          },
      },
      debouncedGetParts: this.debounce(this.getParts, 500), // Adjust the delay time (500ms) as needed
      headers: [
            {
            text: 'Α/Α',
            align: 'start',
            //sortable: false,
            value: 'Id',
            width: '5%',
          },
          { text: 'Κατηγορία', value: 'CategoryId', width: '10%',
          filter: (value) => {
            if (!this.category) return true;
            return value == this.category;
            },
          },
          {
            text: 'Κωδικός',
            align: 'start',
            //sortable: false,
            value: 'FmSku',
            width: '5%',
          },
          { text: 'Περιγραφή', value: 'Description', width: '50%'},
          { text: 'Τιμή λιανικής', value: 'RetailPrice', align: 'end', groupable: false },
         //{ text: 'Τιμή χονδρικής', value: 'BulkPrice', align: 'end', groupable: false },
          { text: 'Απόθεμα', value: 'StockQty', align: 'end', groupable: false,
           filter: (value) => {
            if (!this.inStock) return true;
            return value > 0;
            },
          },
          { text: 'Actions', value: 'actions', groupable: false },
          { text: '', value: 'data-table-expand' },
        ],
    }
  },
  async created() {
      try {
         //await this.getParts()
        const catresponse = await this.$api.get('/inventory/parts/categories');
        // console.log(response);
        this.partCategories = catresponse.data;
      } catch (error) {
        console.error(error);
      }
    },
  watch: {
      timdialog (val) {
        val || this.close()
      },
      options: {
        handler () {
          this.getParts()
        },
        deep: true,
      },
      category: {
        handler () {
          this.getParts()
        },
        deep: true,
      },
      search: {
        handler: function() {
          this.debouncedGetParts();
      },
        deep: true,
      },
  },
  methods: {
  showdialog(item) {
    //console.log(item, this.timdialog)
    this.diaitems = item.line_items;
    this.timdialog = true;
  },
  close () {
        this.timdialog = false
  },
    async createPart() {
      let part = this.newPart;
      part.References = JSON.parse(this.newPart.References);
      part.PartProperties = JSON.parse(this.newPart.PartProperties);
      var response = await this.$api.post("/inventory/parts/create", part);
      console.log(response);
      this.dialog = false;
    },
    debounce(func, delay) {
      let timeoutId;
      return function() {
          const context = this;
          const args = arguments;
          clearTimeout(timeoutId);
          timeoutId = setTimeout(() => func.apply(context, args), delay);
      };
    },
  async getParts() {
        const { page, itemsPerPage } = this.options
         let offset = 0
         if (page > 1) { offset = page * itemsPerPage}

        
        if (this.search && this.search.length >=3) {
                let searchDesc= !this.search.startsWith("#")
                let search = this.search;
                if (!searchDesc) {
                    search = search.slice(1,-1);
                }
                this.loading = true
              await this.$api.get('/inventory/parts/search',
        { params: { offset: offset , limit: 150, desc: searchDesc, query: search, category: this.category}  }
        ).then(res => {
                        this.parts = res.data;
                        this.partsLength = res.data.length;
                    })
                    .catch(err => console.log(err.response.data))
                    .finally(() => this.loading = false);
        
            return    
        }
        
        if (!this.search) {
  
        this.loading = true
        const response = await this.$api.get('/inventory/',
        { params: { offset: offset , limit: itemsPerPage, category: this.category}  }
        );
        // console.log(response);
        this.parts = response.data;
        
        this.partsLength = await this.$api.get('/inventory/count',
        { params: { category: this.category}  }
        ).then((response) => {return response.data});
        // console.log(response);
        this.parts = response.data;
        this.loading = false
        }
  },
  async save() {
      let item = this.editedItem;
      item.InvoiceId = null;
      // console.log(item);

      if (item.Id) {
        const response = await this.$api.patch("/inventory/parts/checkin/"+item.Id, item)
          //console.log(response);
          item.Sku = response.data.Sku;
          item.Id = response.data.Id;
          item.Description = response.data.Description;

      } else {
        const response = await this.$api.post("/inventory/parts/checkin/", item)
          console.log(response);
        item.Id = response.data.Id;
        item.Description = response.data.Description;
        alert("Created!")
      }
  },
      
  async updateParts() {
    if (this.partsFile) {
      try {
        var formData = new FormData();
        formData.append("parts_file", this.partsFile);
        let resp = await this.$api.post("/inventory/parts/bulk-update", formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        if (resp.status == 201) {
          alert("Τα ανταλλακτικά ενημερώθηκαν", resp.data.added);
        } else {
          alert("Σφάλμα ενημέρωσης");
          console.log(resp);
        }
        this.partsFile = null;
        this.loading = true;
         const response = await this.$api.get('/inventory/');
        // console.log(response);
        this.parts = response.data;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    }
  },
  toggleBarcodeInput() {
      this.showBarcodeInput = !this.showBarcodeInput;
       if (this.showBarcodeInput) {
        this.$nextTick(() => {
          this.$refs.barcodeInput.focus();
        });
      }
  },
  handleBarcodeEnter() {
      const barcodeInput = this.$refs.barcodeInput;
      const barcode = barcodeInput ? barcodeInput.$el.querySelector('input').value.trim() : '';
      if (barcode) {
        let bid = null;

        if (barcode.startsWith('PIC-')) {
          bid = parseInt(barcode.substring(4), 10);
          this.navigateTo('part-info', bid);
        } else if (barcode.startsWith('OIC-')) {
          bid = parseInt(barcode.substring(4), 10);
          this.navigateTo('Order', bid);
        } else if (barcode.startsWith('http://')) {
          const regex = /^http:\/\/(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}):8080\/part\/(\d+)\/info$/;
          const match = barcode.match(regex);
          if (match) {
            const bid = parseInt(match[2], 10);
            this.navigateTo('part-info', bid);
          } else {
            this.barcodeError = true;
            this.barcodeErrorMessage = 'Invalid barcode URL format';
          }
        } else {
          bid = parseInt(barcode, 10);
          if (!isNaN(bid)) {
            this.navigateTo('Order', bid);
          }
        }
        this.barcode = ''; // Clear the input after processing
      }
/*
      if (barcode.startsWith('PIB-')) {
        this.handleBarcodeResult(id, barcode.startsWith('PB-') ? 'FmSku' : 'Id');
      } else {
        this.barcodeError = true;
        this.barcodeErrorMessage = 'Invalid barcode format or no matching part found';
      }
        this.$router.push({ name: 'part-info', params: { id: this.barcode } });
        this.barcode = ''; // Clear the input after processing
        this.showBarcodeInput = false; // Optionally hide the input after processing
  */
  },

   navigateTo(routeName, id) {
      if (this.openInNewTab) {
        const url = this.$router.resolve({ name: routeName, params: { id } }).href;
        window.open(url, 'barcode', 'popup');
        window.focus();
      } else {
        this.$router.push({ name: routeName, params: { id } });
      }
  },

  tocurr(value) {
    return new Intl.NumberFormat("el-GR", {
      style: "currency",
      currency: "EUR",
    }).format(value.toFixed(2));
  },

  uniq(items, key) {
    //Store the unique
    let uniques = [];

    //Track the items added to the uniques
    let itemsFound = {};
    for (let val of items) {
      //If item is already added then move to the next item
      if (itemsFound[val[key]]) {
        continue;
      }

      //Else push it to the unique list
      uniques.push(val[key]);

      //Mark it as added
      itemsFound[val[key]] = true;
    }

    //Return the uniques
    return uniques;
  },
  remove(obj, item) {
    obj.splice(obj.indexOf(item), 1);
    obj.vehicle = [...obj];
  },
  }
}
</script>
<style scoped>
.barcode-input-container {
  display: flex;
  align-items: center;
}

.barcode-text-field {
  margin-left: 8px; /* Adjust as needed */
  margin-top: -5px;
}

</style>